import type { SanityRailsArchitecture } from '#/lib/sanity/queries/sections';
import { createSanityFieldDataAttribute } from '#/lib/sanity/visualEditing';
import type { PageLayoutSharedProps } from '#/lib/types';
import { useMediaQuery } from '#/lib/useMatchMedia';

import { DesktopAnimation } from './DesktopAnimation';
import { MobileAnimation } from './MobileAnimation';

export function RailsArchitecture(
  props: SanityRailsArchitecture & PageLayoutSharedProps,
) {
  // Same breakpoint handling as HomePagePainpoint: render the stacked
  // layout until the desktop media query has resolved on the client.
  const [desktopMatches, hasRunDesktop] = useMediaQuery({ screen: 1200 });
  const showDesktop = desktopMatches && hasRunDesktop;

  return (
    <div className="bg-[linear-gradient(to_bottom,#1c1c1e_57.5%,#504cc5_100%)] px-20 py-80 text-cloud m:px-40 m:py-100 xl:px-80">
      <div className="mx-auto flex max-w-[1280px] flex-col items-center gap-48 m:gap-63">
        <h2
          className="max-w-[800px] text-balance text-center text-32 font-normal leading-105 tracking-[-0.8px] m:text-40"
          data-sanity={createSanityFieldDataAttribute(
            props.sanitySource,
            'headline',
          )}
        >
          {props.headline}
        </h2>
        <div className="fade-in w-full">
          {showDesktop ? <DesktopAnimation /> : <MobileAnimation />}
        </div>
      </div>
    </div>
  );
}
